import React from "react";
import { Input } from "components/ui/input";
import { ClientPhoneIcon } from "components/Icons";
import { seatSizes } from "utils";
import { useFormContext } from "react-hook-form";
import MultiSelectField from "components/Checkbox/HorseProfile/HorseMultiSelect";

export const ContactInformation = ({
  handlePhoneNumberChange,
  selectedSize,
  handleSizeChange,
}) => {
  const formContext = useFormContext();

  const {
    register,
    formState: { errors },
  } = formContext;
  return (
    <div className="flex flex-wrap mt-[24px] gap-[20px] xl:gap-[35px]">
      <div className="flex items-center flex-wrap gap-[18px] w-full">
        <div className="sm:flex items-center gap-y-[20px] sm:gap-2 lg:gap-[18px] w-full max-w-full">
          <div>
            <Input
              {...register("phone")}
              icon={<ClientPhoneIcon className="!text-transparent" />}
              type="tel"
              label="Phone Number"
              name="phone"
              placeholder="(555) 555-5555"
              className="w-full sm:w-[335px] mb-[20px] sm:mb-0 xl:w-[399px]"
              maxLength={14}
              onChange={handlePhoneNumberChange}
            />
            <div className="h-2">
              {errors.phone && (
                <p className="text-red-500 text-sm font-montserrat mt-1">
                  {errors.phone?.message}
                </p>
              )}
            </div>
          </div>

          <div className="w-full sm:w-auto">
            <MultiSelectField
              className="cactus_dropdown_formInput w-full sm:w-[335px] xl:w-[399px] text-[14px]"
              label="Seat Size"
              placeholder="Select Size"
              value={selectedSize}
              options={seatSizes}
              onChange={handleSizeChange}
            />
            {errors.size && (
              <p className="text-red-500 text-sm font-montserrat mt-1">
                {errors.size?.message}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
